<div class="calendar-header-container display-flex justify-content-space-between align-items-center">
  <button mat-icon-button class="nav-button" (click)="previousClicked()">
    <app-icon [iconColor]="EColorPalette.cGray7" [iconHeight]="8" [iconWidth]="14" [svg]="EIcon.ANGLE_LEFT"></app-icon>
  </button>
  <div class="header-selectors display-flex align-items-center grid-gap-6">
    <span
      class="menu-trigger fs s14"
      [matMenuTriggerFor]="monthMenu"
      (menuOpened)="monthMenuOpen = true"
      (menuClosed)="monthMenuOpen = false">
      {{ selectedMonthLabel }}
      <app-icon
        class="caret-icon"
        [iconColor]="EColorPalette.cGray11"
        [iconHeight]="12"
        [iconWidth]="12"
        [svg]="monthMenuOpen ? EIcon.CARET_UP : EIcon.CARET_DOWN"></app-icon>
    </span>
    <span
      class="menu-trigger fs s14"
      [matMenuTriggerFor]="yearMenu"
      (menuOpened)="yearMenuOpen = true"
      (menuClosed)="yearMenuOpen = false">
      {{ selectedYear }}
      <app-icon
        class="caret-icon"
        [iconColor]="EColorPalette.cGray11"
        [iconHeight]="12"
        [iconWidth]="12"
        [svg]="yearMenuOpen ? EIcon.CARET_UP : EIcon.CARET_DOWN"></app-icon>
    </span>
  </div>
  <button mat-icon-button class="nav-button" (click)="nextClicked()">
    <app-icon [iconColor]="EColorPalette.cGray7" [iconHeight]="8" [iconWidth]="14" [svg]="EIcon.ANGLE_RIGHT"></app-icon>
  </button>
</div>

<mat-menu
  #monthMenu="matMenu"
  xPosition="before"
  class="menu-offset menu-with-backdrop menu-with-backdrop-max-height-12-items">
  <button mat-menu-item *ngFor="let month of months; let monthIndex = index" (click)="selectMonth(monthIndex)">
    {{ month }}
  </button>
</mat-menu>

<mat-menu #yearMenu="matMenu" class="menu-offset menu-with-backdrop menu-with-backdrop-max-height-10-items">
  <button mat-menu-item *ngFor="let year of years" (click)="selectYear(year)">
    {{ year }}
  </button>
</mat-menu>
